import React from 'react';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { HouseholdBalanceSheetPage } from './HouseholdBalanceSheetPage';

export default function HouseholdBalanceSheetPageTemplate({ resource, collection }) {
  const {
    refreshPageContentCollection,
    loadPageContentLink,
    setPageContentCollection,
  } = usePageContentContext();

  useBoneBackgroundColor();

  return <HouseholdBalanceSheetPage collection={collection} setCollection={setPageContentCollection} resource={resource} refresh={refreshPageContentCollection} navigate={loadPageContentLink} />;
}

HouseholdBalanceSheetPageTemplate.defaultProps = {
};

HouseholdBalanceSheetPageTemplate.propTypes = {
  resource: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
};
